import { lazy } from 'react';

export default {
  exact: false,
  name: 'GIMAC Credit purchase',
  protected: true,
  path: '/gimac-purchase-credit',
  component: lazy(() => import('containers/Gimac/PurchaseCredit')),
};
